import { render, staticRenderFns } from "./UploadFilePdf.vue?vue&type=template&id=21f901cb"
import script from "./UploadFilePdf.vue?vue&type=script&lang=js"
export * from "./UploadFilePdf.vue?vue&type=script&lang=js"
import style0 from "./UploadFilePdf.vue?vue&type=style&index=0&id=21f901cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports